import { MiningPlanDaysE } from "@services/auth";
import { IMiningPlanOptions } from "@services/getMinerList";
import {
  ActionBaseMiningPlans,
  ActionSetMiningPlans,
  ActionUpdateMiningPlan,
  ActionTypesMiningPlansE,
  ActionDeleteMiningPlan,
} from "./actionTypes";

// const mockPlan: IMiningPlanOptions[] = [
//   {
//     id: "default",
//     name: "default",
//     days: [],
//     time_picker: [["", ""]],
//   },
//   {
//     id: "sdfgsdg324234",
//     name: "Plan #1",
//     days: [
//       MiningPlanDaysE.MON,
//       MiningPlanDaysE.FRI,
//       MiningPlanDaysE.SUN,
//       MiningPlanDaysE.SAT,
//       MiningPlanDaysE.THU,
//     ],
//     time_picker: [
//       ["10:30", "15:00"],
//       ["20:00", "23:00"],
//     ],
//   },
//   {
//     id: "123sdgdsfhthsg",
//     name: "Plan #2",
//     days: [MiningPlanDaysE.MON, MiningPlanDaysE.FRI],
//     time_picker: [["20:00", "23:00"]],
//   },
// ];

const initialState = {
  mining_plans: null,
};

const miningPlanReducer = (
  state: { mining_plans: IMiningPlanOptions[] | null } = initialState,
  action: ActionBaseMiningPlans
) => {
  switch (action.type) {
    case ActionTypesMiningPlansE.SET_MINING_PLANS:
      const { mining_plans } = (action as ActionSetMiningPlans).payload;
      return {
        ...state,
        mining_plans,
      };

    case ActionTypesMiningPlansE.UPDATE_PLAN: {
      const payload = (action as ActionUpdateMiningPlan).payload;
      const planIndex = state.mining_plans?.findIndex(
        (p) => p.id === payload.id
      );
      if (planIndex === -1 || planIndex === undefined) return state;
      const plans = state.mining_plans || [];
      return {
        ...state,
        mining_plans: [
          ...plans.slice(0, planIndex),
          payload,
          ...plans.slice(planIndex + 1),
        ],
      };
    }
    case ActionTypesMiningPlansE.CLEAR_MINING_PLANS:
      return {
        ...state,
        mining_plans: null,
      };
    case ActionTypesMiningPlansE.DELETE_PLAN:
      const id = (action as ActionDeleteMiningPlan).payload;
      const findIndex = state.mining_plans?.findIndex((p) => p.id === id);
      if (!findIndex) return state;
      const plans = state.mining_plans || [];
      return {
        ...state,
        mining_plans: [
          ...plans.slice(0, findIndex),
          ...plans.slice(findIndex + 1),
        ],
      };
    default:
      return state;
  }
};

export default miningPlanReducer;
